export const tipQuestion = `
  question
  slug
`;

export const tipSummary = `
  ${tipQuestion}
  inLanding
  introduction
`;
